interface AccommodationInterface {
  id:number
}

class Accommodation implements AccommodationInterface{
  id:number 
  name:string 
  color:string|null
  short_name:string|null

  constructor(
    id:number,
    name:string, 
    color:string|null,
    short_name:string|null
  ){
    this.id = id
    this.name = name 
    this.color = color
    this.short_name = short_name
  }
  
}



export default Accommodation